module.exports = "/static/assets/c6a87046d9f91f59c572d486f146a05f.png";